const formatImageUrl = url => {
  const urlWithoutProtocol = url.replace(/(^\w+:|^)\/\//, "");
  return `//${urlWithoutProtocol}`;
};

export default formatImageUrl;
